import { render, staticRenderFns } from "./tzproduct8.vue?vue&type=template&id=46f40486&scoped=true"
import script from "./tzproduct8.vue?vue&type=script&lang=js"
export * from "./tzproduct8.vue?vue&type=script&lang=js"
import style0 from "./tzproduct8.vue?vue&type=style&index=0&id=46f40486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f40486",
  null
  
)

export default component.exports